export default {
  LIST_FETCHED: 'TERMS_OF_USE_FETCHED',
  LIST_LOAD: 'TERMS_OF_USE_LOAD',
  ITEM_DETAIL: 'TERMS_OF_USE_DETAIL',
  BUTTON_LOAD: 'TERMS_OF_USE_BUTTON_LOAD',
};
